import { useUncontrolledInput } from '@libs/ui/ds'
import type { ChangeEvent } from 'react'

const handleMinMax = (
  value?: string,
  min?: string | number,
  max?: string | number
): string | undefined => {
  const numValue = value === '' || !value ? '' : value

  if (max !== undefined && Number(numValue) > Number(max)) {
    return max.toString()
  }

  if (min !== undefined && Number(numValue) < Number(min)) {
    return min.toString()
  }

  return value
}

type Props = {
  value?: string
  defaultValue?: string
  onChange?: (value: ChangeEvent<HTMLInputElement>) => void | undefined
  min?: string | number
  max?: string | number
}

export function useUncontrollerNumberInput({
  value,
  defaultValue,
  onChange,
  min,
  max
}: Props) {
  const managedValue = handleMinMax(value, min, max)

  const [controlledValue, setControlledValue] = useUncontrolledInput({
    value: managedValue,
    defaultValue,
    onChange
  })

  return { controlledValue, setControlledValue }
}
